var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2008_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4931 8.7625C14.6894 7.4525 13.6913 6.74813 12.3275 6.27813L12.77 4.50312L11.69 4.23438L11.2588 5.9625C10.975 5.89125 10.6838 5.825 10.3931 5.75875L10.8275 4.01938L9.74752 3.75L9.30502 5.52437C9.07002 5.47062 8.83877 5.41813 8.61502 5.36188L8.61627 5.35625L7.12627 4.98437L6.83877 6.13813C6.83877 6.13813 7.64064 6.32188 7.62377 6.33313C8.06127 6.4425 8.14002 6.73187 8.12689 6.96187L7.62314 8.98375C7.65314 8.99125 7.69189 9.0025 7.73564 9.01937L7.62127 8.99125L6.91502 11.8237C6.86127 11.9562 6.72564 12.1556 6.41939 12.08C6.43064 12.0956 5.6344 11.8844 5.6344 11.8844L5.09814 13.1206L6.50439 13.4713C6.76564 13.5369 7.02189 13.6056 7.27377 13.67L6.82689 15.465L7.90627 15.7337L8.34877 13.9587C8.64377 14.0381 8.93002 14.1119 9.21002 14.1819L8.76877 15.9494L9.84877 16.2181L10.2956 14.4269C12.1381 14.7756 13.5231 14.635 14.1063 12.9688C14.5763 11.6275 14.0831 10.8531 13.1138 10.3488C13.82 10.1863 14.3513 9.72188 14.4931 8.7625V8.7625ZM12.0244 12.2238C11.6913 13.5656 9.43189 12.84 8.69939 12.6581L9.29315 10.28C10.0256 10.4631 12.3738 10.825 12.0244 12.2238ZM12.3588 8.74313C12.0544 9.96375 10.1744 9.34313 9.56502 9.19125L10.1025 7.035C10.7119 7.18687 12.6763 7.47 12.3588 8.74313Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2008_160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.2f5708417fe21a8512c802836c67b8ee.svg";
export { ForwardRef as ReactComponent };